import { WalletType } from "../enums/AppEnums";

export const getPaymentPath = (type?: WalletType): string => {
  switch (type) {
    case WalletType.Crypto:
      return "busha";
    case WalletType.FlutterwaveKenya:
      return "flutter";
    case WalletType.Paypal:
      return "paypal";
    case WalletType.Paystack:
      return "paystack";
    case WalletType.Kora:
      return "kora";
  }
  return "";
};

export const getPaymentType = (path?: string): WalletType | undefined => {
  switch (path) {
    case "busha":
      return WalletType.Crypto;
    case "flutter":
      return WalletType.FlutterwaveKenya;
    case "paypal":
      return WalletType.Paypal;
    case "paystack":
      return WalletType.Paystack;
    case "kora":
      return WalletType.Kora;
  }
  return undefined;
};
